// 검차 결과 사진/영상 — 시안 A3 `photosBlock`(세그 2 + 그리드).
// 썸네일은 기존 인증 경로를 그대로 쓴다(utils/useEvalThumbBlobs → /eval/orders/:id/photos/:file/thumb).
// 원본·영상은 응답의 서명 url 을 그대로 쓴다. 카테고리 분류(OrderPhotos)는 관리자 화면 전용 —
// 바이어 화면은 한국어 카테고리 라벨을 노출하지 않으므로 단일 그리드로 둔다.
// props: { photos, cols }   photos = normalizePhotos(eval_result)
//   cols 를 주면 고정 열수(데스크톱 패널 — ≥1200 4열 / 1024~1199 3열). 없으면 기존 auto-fill(모바일 무변경).
import React, { useState } from 'react';
import { T, R } from '../../../theme';
import { useT } from '../../../../i18n/I18nProvider';
import useEvalThumbBlobs from '../../../../utils/useEvalThumbBlobs';
import LtrText from '../../parts/LtrText';
import Lightbox from './Lightbox';

var VIDEO_RE = /\.(mp4|mov|avi|webm|3gp)$/i;

var box = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, padding: 9 };
var seg = { display: 'grid', gridTemplateColumns: '1fr 1fr', background: T.track, borderRadius: R.md, padding: 3 };
var segBtn = { textAlign: 'center', padding: 5, fontSize: 11.5, fontWeight: 700, color: T.muted, borderRadius: R.sm,
  border: 0, background: 'none', cursor: 'pointer', fontFamily: 'inherit', minWidth: 0 };
var segOn = Object.assign({}, segBtn, { background: T.card, color: T.ink, boxShadow: '0 1px 3px rgba(15,23,42,.08)' });
var grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(78px, 1fr))', gap: 5, marginTop: 9, direction: 'ltr' };
// padding:0 (button 기본 패딩 제거) 은 paddingTop 보다 먼저 — 뒤에 오면 정사각 스페이서가 지워져 셀 높이 2px (V2 D5)
var cell = { position: 'relative', width: '100%', padding: 0, paddingTop: '100%', borderRadius: R.sm,
  border: '1px solid ' + T.bd, background: T.head, overflow: 'hidden', cursor: 'pointer' };
var fill = { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' };
var emptyStyle = { padding: '18px 0', textAlign: 'center', fontSize: 12, color: T.faint };

export function isVideoPhoto(p) {
  var name = (p && p.filename) || String((p && p.url) || '').split(/[?#]/)[0];
  return VIDEO_RE.test(name);
}

function ResultPhotos(props) {
  var t = useT();
  var all = props.photos || [];
  var st = useState(false); var showVideo = st[0], setShowVideo = st[1];
  var stB = useState(''); var big = stB[0], setBig = stB[1];
  var videos = all.filter(isVideoPhoto);
  var images = all.filter(function (p) { return !isVideoPhoto(p); });
  var thumbBlobs = useEvalThumbBlobs(images);
  var list = showVideo ? videos : images;
  var gridStyle = props.cols
    ? Object.assign({}, grid, { gridTemplateColumns: 'repeat(' + props.cols + ', minmax(0, 1fr))' })
    : grid;

  return (<div className="ss-result-photos" style={box}>
    <div style={seg}>
      <button type="button" data-seg="photos" style={showVideo ? segBtn : segOn} onClick={function () { setShowVideo(false); }}>
        {t('simplePhotos')} <LtrText>{images.length}</LtrText>
      </button>
      <button type="button" data-seg="video" style={showVideo ? segOn : segBtn} onClick={function () { setShowVideo(true); }}>
        {t('simpleVideo')} <LtrText>{videos.length}</LtrText>
      </button>
    </div>
    {list.length ? (<div style={gridStyle}>
      {list.map(function (p, i) {
        if (showVideo) {
          return (<span key={p.url || i} style={Object.assign({}, cell, { cursor: 'default' })}>
            <video src={p.url} controls style={Object.assign({}, fill, { background: T.ink })} />
          </span>);
        }
        // 썸네일 blob 이 도착하기 전에는 빈 src 대신 자리(회색 셀)만 둔다 — 빈 src 는 재다운로드를 유발한다.
        var blob = thumbBlobs[p.url];
        return (<button key={p.url || i} type="button" style={cell} onClick={function () { setBig(p.url); }}>
          {blob ? <img src={blob} alt={p.memo || t('simplePhotos')} loading="lazy" decoding="async" style={fill} /> : null}
        </button>);
      })}
    </div>) : <div style={emptyStyle}>{t('evalEmpty')}</div>}
    <Lightbox src={big} alt={t('simplePhotos')} onClose={function () { setBig(''); }} />
  </div>);
}

export default ResultPhotos;
